// src/i18n/en/tagTypes.js
export const tagTypes = {
    name: 'ID Type |||| ID Types',
    title: 'ID Types',
    titles: {
        list: 'ID Types',
        create: 'Create ID Type',
        edit: 'Edit ID Type',
    },
    fields: {
        id: 'ID',
        typeCode: 'Type Code',
        name: 'Name',
        description: 'Description',
        icon: 'Icon',
        color: 'Color',
        canEdit: 'Editable',
        canDelete: 'Deletable',
        isSystemGenerated: 'System Generated',
        requiresManualInput: 'Manual Input',
        createdAt: 'Created',
        updatedAt: 'Updated',
        search_placeholder: 'Search ID types...',
        system_tooltip: 'System generated (not editable)',
        display_name: 'Display Name',
        unique_identifier: 'Unique identifier',
        readable_name: 'Human readable name for users',
        character_count: 'characters'
    },
    actions: {
        create: 'New ID Type',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        save: 'Save Changes',
        create_submit: 'Create ID Type'
    },
    messages: {
        access_denied: 'Access Denied. Only SuperAdmins can manage ID types.',
        no_types: 'No ID types found',
        loading: 'Loading types...',
        create_success: 'ID Type created successfully',
        update_success: 'ID Type updated successfully',
        delete_success: 'Type deleted successfully',
        delete_confirm: 'Are you sure you want to delete the ID type "%{name}"?',
        delete_warning: 'This action cannot be undone.',
        system_type: 'This is a system type and cannot be modified',
        create_info: 'ID types define how guests access their lockers. Only system administrators can create new types.',
        edit_warning: 'Changing the "Type Code" may affect existing IDs that use this type.'
    },
    tooltips: {
        system_generated: 'System can generate codes automatically',
        manual_only: 'Manual entry only',
        requires_manual: 'Requires manual user input',
        automatic: 'Automatic generation',
    },
    sections: {
        new_title: 'New ID Type',
        new_subtitle: 'Complete the data to create a new ID type',
        details: 'ID Type Details',
    },
    help: {
        typeCode: 'Select the identifier type',
        name: 'Human readable name for users',
        description: 'Optional description (max 500 characters)',
        displayName: 'Human readable name for users',
        manualInput: 'If checked, requires user to manually enter the code'
    },
    validation: {
        code_required: 'Code is required',
        code_format: 'Code must be alphanumeric',
        name_required: 'Name is required',
        typeCode_validation: 'Unique identifier (e.g. CARD_UID)',
        name_validation: 'Human readable name for users',
        description_validation: '0/500 characters',
        type_code_required: 'Type Code is required',
        type_code_min_length: 'Must be at least 3 characters',
        type_code_no_spaces: 'Cannot contain spaces',
        type_code_format: 'Only uppercase letters, numbers and underscores',
        name_min_length: 'Must be at least 3 characters',
        description_max_length: 'Description cannot exceed 500 characters'
    },
    dialogs: {
        delete_title: 'Delete ID Type',
        delete_message: 'Are you sure you want to delete the ID type "%{name}"?',
        delete_warning: 'This action cannot be undone.'
    },
    examples: {
        title: 'Common examples:',
        nfc_uid: 'Hotel NFC Card',
        qr_code: 'QR Code (auto-generated)',
        numeric_code: '8-digit numeric code',
        barcode_128: 'Standard barcode format'
    },
    notifications: {
        type_updated_success: 'ID Type updated successfully',
    }
};